import React from 'react';
import { Lock, TrendingUp, BarChart2, ArrowUpRight } from 'lucide-react';

const TIER_BADGE = {
  Growth:     { cls: 'bg-blue-100 text-blue-700',    Icon: TrendingUp },
  Enterprise: { cls: 'bg-purple-100 text-purple-700', Icon: BarChart2  },
};

/**
 * Wraps the real page component in a blur + lock overlay.
 * children = the actual page (DashboardInsights, SmartActions, etc.)
 * The real page renders and makes its API calls normally — so the preview
 * shows the exact same design (and real data, just unreadable through the blur).
 * After upgrading the user sees the identical UI, just unblurred with full access.
 */
const LockedPage = ({ featureName, requiredTier, description, children }) => {
  const { cls: badgeCls, Icon: BadgeIcon } = TIER_BADGE[requiredTier] || { cls: 'bg-muted text-muted-foreground', Icon: Lock };

  return (
    <div className="relative overflow-hidden" style={{ minHeight: 'calc(100vh - 4rem)' }}>

      {/* Real page — blurred so the design is visible but numbers are unreadable */}
      <div
        className="pointer-events-none select-none"
        style={{ filter: 'blur(2px)', opacity: 0.7 }}
        aria-hidden="true"
      >
        {children}
      </div>

      {/* Subtle darkening scrim */}
      <div className="absolute inset-0" style={{ background: 'rgba(0,0,0,0.12)' }} />

      {/* Lock card — centred */}
      <div className="absolute inset-0 flex items-center justify-center px-4">
        <div className="bg-card border shadow-2xl rounded-2xl p-8 max-w-sm w-full text-center">

          <div className="w-14 h-14 bg-muted rounded-full flex items-center justify-center mx-auto mb-4">
            <Lock className="h-6 w-6 text-muted-foreground" />
          </div>

          <span className={`inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-full mb-4 ${badgeCls}`}>
            <BadgeIcon className="h-3 w-3" />
            {requiredTier} Plan
          </span>

          <h2 className="text-lg font-semibold mb-2">{featureName}</h2>
          <p className="text-sm text-muted-foreground mb-6">{description}</p>

          <div className="flex items-center justify-center gap-1.5 text-sm font-semibold text-primary">
            <ArrowUpRight className="h-4 w-4" />
            Contact your administrator to upgrade
          </div>

        </div>
      </div>

    </div>
  );
};

export default LockedPage;
